import React, { useLayoutEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import FloorPlanner from "./components/FloorPlanner";
import InstructionsPage from "./components/InstructionsPage";
import WelcomeScreen from "./components/WelcomeScreen";
import ThreeDView from "./components/ThreeDView";
import "./App.css";

function App() {
  const [logsShown, setLogsShown] = useState(false);
  const originalLogger = useRef(window.console.log);
  // useLayoutEffect(() => {
  //   if (!logsShown) {
  //     window.console.log = () => {};
  //   } else window.console.log = originalLogger.current;
  // }, [logsShown]);

  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route path="/" element={<WelcomeScreen />} />
          <Route path="/planner" element={<FloorPlanner />} />
          <Route path="/instructions" element={<InstructionsPage />} />
          <Route path="/3d-view" element={<ThreeDView />} />
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;
